<template>
  <div id="app">
    <search-bar ref="searchBarComponent">

      <div slot="search-cont">

        <div class="item">
          <div class="item-label">菜单名称</div>
          <div style="width: 300px;">
            <el-input placeholder="请输入内容" v-model="info.car_name" class="input-with-select" size="small" @keyup.enter.native='searchMenu'></el-input>
          </div>
        </div>
        <!--  操作按钮 start -->
          <div class="item">
            <el-button class="item-btn" type="primary" @click="searchMenu">查询</el-button>
           
          </div>
        <!--  操作按钮 end -->

      </div>
    </search-bar>
    <div class="operation-tool">
      <div @click="addMenu()" class="tool-item"> <img src="../../../static/img/btn/add.png" /> 添加菜单</div>
    </div>
    <div class="l-panel">
      <div class="panel-body">
        <el-table class="l-table" :data="tableData" style="width: 100%"
         row-key="id" :default-expand-all="default_expand_all"  :tree-props="{children: 'children', hasChildren: 'hasChildren'}"> >
          <el-table-column prop="name" label="菜单名称" align="left" ></el-table-column>
          <el-table-column prop="name" label="是否菜单" align="left" >
            <template slot-scope='{row}'>
              <span v-if="row.menu_type==1">菜单</span>
              <el-link v-else type="primary" :underline="false">功能/按钮</el-link>
            </template>
          </el-table-column>

          <el-table-column prop="car_number" label="级别" >
            <template slot-scope='{row}'>
              <span v-if="row.menu_type==1">
                {{row.pid==0?"头部":"左侧"}}
              </span>

            </template>
          </el-table-column>
          <el-table-column prop="display" label="是否激活" >
            <template slot-scope='{row}'>
                <span v-if="row.display">已激活</span>
                <el-link v-else type="danger">未激活</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="ordid" label="排序" ></el-table-column>
         
          <el-table-column label="操作" >
            <template slot-scope='{row}'>
                <el-button type="text"  @click='editMenu(row)'><i class="el-icon-edit"></i> 编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>


    <el-dialog class="el-dialog-medium" :title="basic.id?'修改菜单':'添加菜单'" :visible.sync="dialogVisible" >
      <div class="dialogContent">
        <el-form :model="basic" ref="basic" label-width="140px" class="demo-ruleForm" :rules="rules" >
          <el-form-item label="父级菜单" >
              <el-cascader style="width: 100%;"
                 @change="selectParentMenu"
                  v-model="basic.pid"
                  placeholder="选择父级菜单"
                  :options="tableData"
                  :props="{ checkStrictly: true,label:'name',value:'id' }"
                  clearable></el-cascader>
          </el-form-item>
          <el-form-item label="菜单/功能名称" prop="name">
              <el-input v-model="basic.name" placeholder="请输入菜单/功能名称"></el-input>
          </el-form-item>
          <el-form-item label="类型"  prop="menu_type">
              <el-radio-group v-model="basic.menu_type">
                <el-radio :label="1">菜单</el-radio>
                <el-radio :label="0">功能/按钮</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item label="是否激活"  prop="display">
            <el-radio-group v-model="basic.display">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="头部菜单激活权限"  >
            <el-radio-group v-model="basic.often">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Module Name"  prop="module_name">
              <el-input v-model="basic.module_name"  placeholder="请输入Module Name"></el-input>
          </el-form-item>
          <el-form-item label="Controller Name"  prop="controller_name">
              <el-input v-model="basic.controller_name" placeholder="请输入Controller Name"></el-input>
          </el-form-item>
          <el-form-item label="Action Name"  prop="action_name">
              <el-input v-model="basic.action_name" placeholder="请输入Action Name"></el-input>
          </el-form-item>
          <el-form-item label="前端路由" >
              <el-input v-model="basic.stat"  placeholder="请输入前端路由"></el-input>
          </el-form-item>
          <el-form-item label="icon图标" >
              <el-input v-model="basic.icon"  placeholder="请输入图标类"></el-input>
          </el-form-item>
          <el-form-item label="备注" >
              <el-input v-model="basic.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label="排序" >
              <el-input v-model="basic.ordid" placeholder="请输入排序号"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('basic')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="el-dialog-medium" title="分配权限组" :visible.sync="addAuthGruopDialogVisible" >
      <div class="dialogContent">
        <el-form :model="gruopForm" ref="gruopForm" label-width="140px" class="demo-ruleForm"  >

          <el-form-item label="被分配菜单/功能" >
              <el-input v-model="gruopForm.name" disabled=""></el-input>
          </el-form-item>
          <el-form-item label="类型"  >
              <el-radio-group v-model="gruopForm.type">
                <el-radio :label="1">仅分配本菜单</el-radio>
                <el-radio :label="2">本菜单及下一级一同分配</el-radio>
              </el-radio-group>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addAuthGruopDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAuthGruopForm('gruopForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        info: {
          page: 1,
          key:'',
          begintimes:[],
          begintime:'',
          endtime:'',
          key_type:''

        },
        default_expand_all:false,
        total: 1,
        tableData:[],
        dialogVisible:false,
        basic:{
          id:"",
          pid:0,//父级id
          name:'',//菜单/功能名称
          menu_type:'1',//菜单类型
          display:'1',//激活
          often:'0',//头部菜单激活权限
          module_name:'',
          controller_name:'',
          action_name:'',
          stat:"",//前端路由
          icon:"",
          remark:"",
          ordid:0,
        },
        rules:{
          name: [ { required: true, message: '请输入菜单/功能名称', trigger: 'blur' },],
          menu_type: [ { required: true, message: '请输入菜单类型', trigger: 'blur' },],
          display: [ { required: true, message: '请选择是否激活', trigger: 'blur' },],
          module_name: [ { required: true, message: '请输入Module Name', trigger: 'blur' },],
          controller_name: [ { required: true, message: '请输入Controller Name', trigger: 'blur' },],
          action_name: [ { required: true, message: '请输入Action Name', trigger: 'blur' },],
        },
        addAuthGruopDialogVisible:false,
        gruopForm:{
          id:"",//菜单id
          name:"",//菜单名称
          type:1,//1-仅分配自己，2-自己及子级一同分配
          mid:"",//模块id
        },

      }
    },

    created() {
          this.$nextTick(() => {
            document.onselectstart = new Function("event.returnValue=true");
          });
    },

    mounted() {
      this.getList()
    },
    methods: {
      addMenu(){
        for(let key in this.basic) {
          this.basic[key] = ''
        }
        this.dialogVisible = true
      },
      editMenu(row){
        this.dialogVisible = true
        for(let key in this.basic) {
          this.basic[key] = row[key]
        }
      },
      selectParentMenu(item) {
        this.basic.pid = item[item.length-1]
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
              this.gets('menu/andOrEditMenu',this.basic).then(res=>{
                if(res.data.code == 1){
                  Message.success(res.data.msg)
                  this.getList()
                  this.dialogVisible = false
                }else{
                  Message.warning(res.data.msg)
                }

              })
          } else {
           return console.log('error submit!!');
          }
        });
      },
      searchMenu() {
        this.getList()
      },

      getList() {
        this.gets('menu/getMenuList').then(res => {
          this.tableData = res.data.data
        })
      },
      //显示授权组弹窗
      showAddAuthGruopDialog(row) {
        this.addAuthGruopDialogVisible = true
        this.gruopForm.id = row.id;
        this.gruopForm.name = row.name;
        this.gruopForm.mid = row.mid;
      },
      submitAuthGruopForm(formName) {
        this.gets('menu/andMenuToAuthGroup',this.gruopForm).then(res=>{
          res.data.code == 1?Message.success(res.data.msg):Message.warning(res.data.msg)
          this.getList()
          this.addAuthGruopDialogVisible = false
        })
      }
    }
  }
</script>

<style scoped>
  .table {
    margin: 30px 0;
    padding: 20px;
    background: #fff;
  }

  .pagination {
    text-align: center;
    width: 100%;
    background: #fff;
    height: 50px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/view/system/systemMenu.vue